<template>
  <div class="navtab">
    ©2017-2020 <a href="http://www.desmix.com">上海逆行信息科技</a>&nbsp;&nbsp;沪ICP备17035474号-2
  </div>
</template>

<script>
export default {
  data() {
    return {
      // a:'aa'
    };
  },
};
</script>

<style scoped lang="less">
.navtab {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  background: #222a36;
  color: #f0f0f0;
  font-size: 14px;
  line-height: 50px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
  a {
    color: #f0f0f0;
    text-decoration: none;
  }
  a:hover{
    text-decoration: underline;
  }
}
@media screen and (max-width: 420px) {

}
</style>



// WEBPACK FOOTER //
// src/components/tabBottom.vue